import { Checkbox, Col, Form, Input, message, Modal, Radio, Row } from 'antd';
import React, { useEffect, useState } from 'react';

const REGEX_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Padrao G3 desta base (ver ModalTemplateEmail/ModalLogomarca) - funcao + hooks,
// sem Form.create()/connect, props visible/onClose. O ModalInvitation antigo
// (nao reaproveitado aqui de proposito) tem 3 problemas estruturais: sem prop
// onClose (cancelar nao fecha de verdade), handleOk nunca recebe o status
// (validateFields sincrono descartando o return), e renderiza um botao gatilho
// proprio no DOM.
export default function ModalConvidarUsuario(props) {
  const { visible, empresa, unidades, onClose, createInvitation } = props;

  const [email, setEmail] = useState('');
  const [tipoAcesso, setTipoAcesso] = useState('total');
  const [idsFiliaisSelecionadas, setIdsFiliaisSelecionadas] = useState([]);
  const [loading, setLoading] = useState(false);

  const reset = () => {
    setEmail('');
    setTipoAcesso('total');
    setIdsFiliaisSelecionadas([]);
  };

  useEffect(() => {
    if (visible) reset();
  }, [visible]);

  const onHandleOk = async () => {
    if (!email || !REGEX_EMAIL.test(email)) {
      message.warning('Informe um e-mail válido.');
      return;
    }
    if (tipoAcesso === 'restrito' && idsFiliaisSelecionadas.length === 0) {
      message.warning('Selecione ao menos uma unidade para o acesso restrito.');
      return;
    }

    setLoading(true);
    const payload = {
      idEmpresa: empresa.id,
      idsFiliais: tipoAcesso === 'restrito' ? idsFiliaisSelecionadas : [],
      emailUser: email.trim(),
    };
    // O feedback de sucesso/erro (message.success/error) e o fechamento do
    // modal ficam por conta de quem chama - mesmo metodo createInvitation ja
    // existente em SettingsBlue, que tambem recarrega a lista de usuarios.
    const sucesso = await createInvitation(payload);
    setLoading(false);
    if (sucesso) {
      reset();
    }
  };

  return (
    <Modal
      visible={visible}
      onCancel={() => onClose()}
      cancelText="Cancelar"
      okText="Convidar"
      title={`Convidar usuário para ${empresa ? empresa.nome : ''}`}
      confirmLoading={loading}
      onOk={onHandleOk}
    >
      <Form>
        <Form.Item label="E-mail do convidado">
          <Input
            placeholder="email@exemplo.com"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </Form.Item>
        <Form.Item label="Nível de acesso">
          <Radio.Group
            value={tipoAcesso}
            onChange={e => setTipoAcesso(e.target.value)}
          >
            <Radio value="total">Acesso total ao grupo</Radio>
            <br />
            <Radio value="restrito">Acesso restrito a unidades específicas</Radio>
          </Radio.Group>
        </Form.Item>
        {tipoAcesso === 'restrito' && (
          <Form.Item label="Unidades">
            {unidades && unidades.length > 0 ? (
              <>
                <Checkbox
                  indeterminate={
                    idsFiliaisSelecionadas.length > 0 &&
                    idsFiliaisSelecionadas.length < unidades.length
                  }
                  checked={idsFiliaisSelecionadas.length === unidades.length}
                  onChange={e =>
                    setIdsFiliaisSelecionadas(
                      e.target.checked ? unidades.map(u => u.id) : []
                    )
                  }
                  style={{ marginBottom: 8 }}
                >
                  Selecionar todas
                </Checkbox>
                <Checkbox.Group
                  style={{ width: '100%' }}
                  value={idsFiliaisSelecionadas}
                  onChange={setIdsFiliaisSelecionadas}
                >
                  <Row>
                    {unidades.map(unidade => (
                      <Col key={unidade.id} span={12}>
                        <Checkbox value={unidade.id}>{unidade.nome}</Checkbox>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
              </>
            ) : (
              <span>Nenhuma unidade cadastrada nessa empresa.</span>
            )}
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
}
